<div class="container">
  <div class="row">
    <div class="title">{{ 'settings.title' | translate }}</div>
  </div>
  <div class="row marginTop64">
    <div class="subtitle">{{ 'settings.account.title' | translate }}</div>
  </div>
  <div class="buttonsContainer marginTop24">
    <div (click)="updateAvatar()" class="button primary ctaBtn">
      {{ 'settings.account.avatar' | translate }}
    </div>
  </div>
  <div class="buttonsContainer marginTop24">
    @if (shouldDisplayLogout()) {
      <div (click)="logout()" class="button danger ctaBtn">
        <i class="bi bi-box-arrow-right"></i>
        {{ 'settings.account.logout' | translate }}
      </div>
    }
    @if (shouldDisplayDelete()) {
      <div (click)="deleteAccount()" class="button danger ctaBtn">
        <i class="bi bi-trash3-fill"></i>
        {{ 'settings.account.deleteAccount' | translate }}
      </div>
    }
  </div>
  <div class="row marginTop64">
    <div class="subtitle">{{ 'settings.theme.title' | translate }}</div>
  </div>
  <div class="buttonsContainer marginTop24">
    <div (click)="setTheme('manga')" class="button primary ctaBtn" [class.active]="isActive('manga')">
      {{ 'settings.theme.manga' | translate }}
    </div>
    <div (click)="setTheme('low-poly')" class="button primary ctaBtn" [class.active]="isActive('low-poly')">
      {{ 'settings.theme.lowPoly' | translate }}
    </div>
    <div (click)="setTheme('vectoriel')" class="button primary ctaBtn" [class.active]="isActive('vectoriel')">
      {{ 'settings.theme.vectoriel' | translate }}
    </div>
  </div>
  <div class="row marginTop64">
    <div class="subtitle">{{ 'settings.video.title' | translate }}</div>
  </div>
  <div class="videoContainer marginTop24">
    <div class="videoBlock">
      <video class="video" controls playsinline webkit-playsinline>
        <source src="https://bedici.s3.fr-par.scw.cloud/illustrations/intro/BeDiCi_version_courte.mp4" type="video/mp4" />
      </video>
    </div>
  </div>
  @if (shouldDisplayCGU()) {
    <div class="row marginTop64">
      <div class="subtitle">{{ 'settings.legal.title' | translate }}</div>
    </div>
    <div class="buttonsContainer marginTop24">
      <div (click)="loadPdf(currentLanguage.code === 'fr' ? '/legal/cgv.pdf' : `/legal/${currentLanguage.code}/cgv.pdf`)" class="button primary ctaBtn">
        {{ 'settings.legal.cgv' | translate }}
      </div>
      <div (click)="loadPdf(currentLanguage.code === 'fr' ? '/legal/datapolicy.pdf' : `/legal/${currentLanguage.code}/datapolicy.pdf`)" class="button primary ctaBtn">
        {{ 'settings.legal.dataPolicy' | translate }}
      </div>
    </div>
  }
  @if (shouldDisplayGarLegal()) {
    <div class="row marginTop64">
      <div class="subtitle">{{ 'settings.legal.title' | translate }}</div>
    </div>
    <div class="buttonsContainer marginTop24">
      <div (click)="loadPdf('/legal/mentions_legales_gar.pdf')" class="button primary ctaBtn">
        {{ 'settings.legal.legalNoticeGar' | translate }}
      </div>
      <div (click)="loadPdf('/legal/rgpd_gar.pdf')" class="button primary ctaBtn">
        {{ 'settings.legal.rgpdPolicyGar' | translate }}
      </div>
    </div>
  }
  <div class="row emptyRow"></div>
</div>
